import React, { Component, Fragment } from 'react';
import { Segment, Header, Form, Grid, Loader, Button, Popup, Input } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';

class ExternalStudentCompletionDetailsForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadingOptions: false,
            onChangeStudent: props.onChangeStudent,
            onSave: props.onSave,
            onCancel: props.onCancel,
        };
    }

    componentDidMount() {
    }

    render() {
        const {
            loadingOptions,
            onSave,
            onCancel,
            onChangeStudent,
        } = this.state;
        const {
            student,
            errors
        } = this.props;

        return (
            <Grid.Column>
                <Segment.Group>
                    <Segment>
                        <Header as="h3">
                            <Header.Content style={{
                                display: 'flex',
                                justifyContent: 'space-between'
                            }}>
                                {/* <FormattedMessage id="externalStudent.enterCompletionDetails"/> */}
                                <div></div>
                                {this.props.edit && !loadingOptions && (
                                    <div>
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.cancel"/>}
                                            position="top center"
                                            trigger={<Button floated="right" icon="cancel" basic color="red" circular
                                                             size="mini" loading={loadingOptions} onClick={onCancel}/>}
                                        />
                                        <Popup
                                            content={<FormattedMessage id="externalStudent.edit"/>}
                                            position="top center"
                                            trigger={<Button floated="right" icon="check" basic color="green" circular
                                                             size="mini" loading={loadingOptions} onClick={() => {
                                                onSave(student);
                                            }}/>}
                                        />
                                    </div>
                                )}
                            </Header.Content>
                        </Header>
                    </Segment>
                    <Segment>
                        {loadingOptions ? (
                            <div style={{
                                paddingTop: '100px',
                                paddingBottom: '100px'
                            }}><Loader active inline="centered"/></div>
                        ) : (
                            <Form>
                                <Form.Field>
                                    <label><FormattedMessage id="externalStudent.graduationDate"/></label>
                                    <FormattedMessage id="externalStudent.enterGraduationDate">
                                        {msg => (
                                            <DateTimePicker
                                                format="D. M. YYYY."
                                                time={false}
                                                placeholder={msg}
                                                value={student.graduationDate ? new Date(student.graduationDate) : null}
                                                onChange={(value) => onChangeStudent({ graduationDate: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field>
                                    <label><FormattedMessage id="externalStudent.certificateNumber"/></label>
                                    <FormattedMessage id="externalStudent.enterCertificateNumber">
                                        {msg => (
                                            <Input
                                                placeholder={msg}
                                                value={student.certificateNumber || ''}
                                                onChange={(e, { value }) => onChangeStudent({ certificateNumber: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field>
                                    <label><FormattedMessage id="externalStudent.dropoutDate"/></label>
                                    <FormattedMessage id="externalStudent.enterDropoutDate">
                                        {msg => (
                                            <DateTimePicker
                                                format="D. M. YYYY."
                                                time={false}
                                                placeholder={msg}
                                                value={student.dropoutDate ? new Date(student.dropoutDate) : null}
                                                onChange={(value) => onChangeStudent({ dropoutDate: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field>
                                    <label><FormattedMessage id="externalStudent.lockedAt"/></label>
                                    <FormattedMessage id="externalStudent.enterLockedAt">
                                        {msg => (
                                            <DateTimePicker
                                                format="D. M. YYYY."
                                                time={false}
                                                placeholder={msg}
                                                value={student.lockedAt ? new Date(student.lockedAt) : null}
                                                onChange={(value) => onChangeStudent({ lockedAt: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                            </Form>
                        )}
                    </Segment>
                </Segment.Group>
            </Grid.Column>
        );
    }
}

export default ExternalStudentCompletionDetailsForm;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentForms/ExternalStudentCompletionDetailsForm.js